import { createAppResolverFactory } from './create-app-resolver.factory';

export const externalAppResolver = createAppResolverFactory(true);
